module.exports = __webpack_public_path__ + "static/media/tcs_logo_simple.29690743.svg";